import React from 'react';
import UserPlayer from "./UserPlayer";
import Constants from "./../../constants/Constants";

export default class MyPlayerBottom extends UserPlayer {
    constructor(gameCtx, entityIndex, args) {
        super(gameCtx, entityIndex, args);

        this.setInitialCoords();
    }

    setInitialCoords = () => {
        let cardHeight = this.getCardsHeight();
        let left = this.getLeftPosForHorizontalLayout();
        if (this.sHeight > this.sWidth) {
            this.firstCardCoords = [left, this.sHeight - cardHeight - 10];
        } else {
            this.firstCardCoords = [left, this.sHeight - cardHeight + 20];
        }
    }

    calcRotateDeg = (cardObj = null) => {
        let deg = 0, currentDeg = 0;
        if (cardObj.ref.current != null) {
            currentDeg = cardObj.ref.current.getCurrentDeg();
        }
        switch (currentDeg) {
            case Constants.CARD_DEG_VERTICAL_TOP: deg = 0; break;
            case Constants.CARD_DEG_VERTICAL_BOTTOM: deg = -180; break;
            case Constants.CARD_DEG_HORIZONTAL_RIGHT: deg = 90; break;;
            case Constants.CARD_DEG_HORIZONTAL_LEFT: deg = -90; break;
            default: deg = 0; break;
            //if another default wanted, can be changed
        }
        return deg;
    }

    getCoordsForNewCard = (cardObj, dinamicRotDeg = true) => {
        let index = this.cards.length;
        return this.getCardCoordsByIndex(cardObj, index, dinamicRotDeg);
    }

    getCardCoordsByIndex = (cardObj, index, dinamicRotDeg = true) => {
        let cards = this.getCards()
        let rotDeg = this.calcRotateDeg(cardObj);
        let cardWidth = this.getCardsWidth();
        let divider = 0
        let left;
        if (dinamicRotDeg && cards.length >= 6) {
            divider = ((cards.length - Constants.MAX_CARD_FOR_EACH_PLAYER) / 2) * cardWidth;
        }
        if (cardWidth * (cards.length) > this.sWidth) {
            left = (this.sWidth / cards.length) * (index)
        }
        else {
            left = this.firstCardCoords[0] + (cardWidth * index) - divider
        }

        return [
            left,
            this.firstCardCoords[1],
            rotDeg,
            this.cardSideShown,
            this.cards.length + 1
        ];
    }

    addBubbleOnBottomPlayer = (text, key) => {
        const MAKE_TEXT_CENTER_OF_BUBBLE = 0.01;
        const MAKE_BUBBLE_MORE_FAR_FROM_CARDS = 0.017 * this.sHeight;
        const RATIO_BETWEEN_BUBBLE_HEIGHT_AND_BUBBLE_WIDTH = 1.18;

        let bottomBubble = this.getCardsHeight() + MAKE_BUBBLE_MORE_FAR_FROM_CARDS;
        let bottomText = bottomBubble + MAKE_TEXT_CENTER_OF_BUBBLE * this.sHeight;
        let bubbleWidth = (this.getBubbleHeight() / RATIO_BETWEEN_BUBBLE_HEIGHT_AND_BUBBLE_WIDTH) * 0.01 * this.sHeight
        let left = (this.sWidth - bubbleWidth) / 2

        let bubblePosition = {
            top: 'auto',
            bottom: `${bottomBubble}px`,
            left: `${left}px`
        };

        let textPosition = {
            top: 'auto',
            bottom: `${bottomText}px`,
            left: `${left}px`
        };

        this.addBubbleAccordingToPosition(text, key, bubblePosition, textPosition);
    }


    addPlayingPlateBottomPlayer = (key) => {
        let playingPlateHeight = this.getCardsHeight() + 40;
        let playingPlateWidth = (Constants.MAX_CARD_FOR_EACH_PLAYER + 4) * this.getCardsWidth()
        let playingPlateLeft = (this.sWidth - playingPlateWidth) / 2
        let playingPlateStyle = {
            width: `${playingPlateWidth}px`,
            height: `${playingPlateHeight}px`,
            borderRadius: '50%/100%',
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            border: '1px',
            position: 'absolute',
            bottom: '0px',
            left: `${playingPlateLeft}px`,
            backgroundColor: 'white',
            zIndex: 0,
            overflow: 'hidden'

        }

        const myPlayerBottomPlayingPlate =
            <div key={key} className="playing-plate-parent" >
                <div style={playingPlateStyle} className="playing-plate"></div>
            </div>;
        this.gameCtx.elementsHandler.addElement(key, myPlayerBottomPlayingPlate);
    }

    addPlayingPlate = () => {
        this.addPlayingPlateBottomPlayer(Constants.ELEMENT_MY_PLAYER_PLAYING_PLATE)
    }

    removePlayingPlate = () => {
        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_PLAYING_PLATE)
    }

    getTitlePlateKey = () => {
        return Constants.ELEMENT_MY_PLAYER_TITLE_PLATE
    }

    getTitlePlateStyle = () => {
        let bottom = this.getCardsHeight() + 20
        let titlePlateStyle = {
            width: `${Constants.TITLE_DIMENSION}vh`,
            height: `${Constants.TITLE_DIMENSION}vh`,
            position: 'absolute',
            left: '67vw',
            bottom: `${bottom}px`,
            zIndex: 3
        }
        return titlePlateStyle
    }

    addPlayerMarkup = () => {
        this.addPlayingPlateBottomPlayer(Constants.ELEMENT_MY_PLAYER_PLAYING_PLATE);
        this.addTitlePlateMarkup();
    }

    removePlayerMarkup = () => {
        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_PLAYING_PLATE)
        this.removeTitlePlateMarkup()
    }
}